import React from 'react';
import './Pagination.scss';
import MaterialIcon from '@material/react-material-icon';
import PropTypes from 'prop-types';
import getPageNumbers from '../../utils/getPageNumbers';

const Pagination = ({ meta, setLimit, setPage }) => {
  if (!meta) return null;

  const start = (meta.current_page - 1) * meta.limit + 1 || 0;
  const end = Math.min(meta.current_page * meta.limit, meta.total_records) || 0;
  const handlePrevious = () => {
    if (meta?.current_page > 1) {
      setPage(meta?.current_page - 1);
    }
  };

  const handleNext = () => {
    if (meta?.current_page < meta?.total_pages) {
      setPage(meta?.current_page + 1);
    }
  };

  const handleLimit = (val) => {
    setLimit(Number(val));
    setPage(1);
  };

  const pages = getPageNumbers(meta.current_page, meta.total_pages);

  return (
    <div className="pagination">
      <div className="pagination-left">
        <span>
          Results: {start} - {end} of {meta.total_records}
        </span>
        |
        <div className="per-page">
          <span>Per page:</span>
          <select value={meta.limit} onChange={(e) => handleLimit(e.target.value)}>
            {[10, 20, 30, 40, 50, 75, 100].map((val) => (
              <option key={val} value={val}>
                {val}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="pagination-right">
        <div
          className={`button-previous ${meta.current_page === 1 ? 'disabled' : ''}`}
          onClick={handlePrevious}
        >
          <MaterialIcon icon="keyboard_arrow_left" />
        </div>
        <div className="page-number">
          {pages.map((p) =>
            p === '...' ? (
              <div key={p} className="number dots">
                <span>...</span>
              </div>
            ) : (
              <div
                key={p}
                className={`number ${meta.current_page === p ? 'active' : ''}`}
                onClick={() => setPage(p)}
              >
                <span>{p}</span>
              </div>
            ),
          )}
        </div>
        <div
          className={`button-next ${meta.current_page === meta.total_pages ? 'disabled' : ''}`}
          onClick={handleNext}
        >
          <MaterialIcon icon="keyboard_arrow_right" />
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  meta: PropTypes.object,
  setLimit: PropTypes.func,
  setPage: PropTypes.func,
};

export default Pagination;
